module.exports = __webpack_public_path__ + "img/MI.26fe059e.svg";